module.exports = __webpack_public_path__ + "img/room-popularity-award_in.0f30f5ab.png";